import axios from 'axios';
import logger from '@/utils/logger';

// Default API URL (fallback if environment variable is not set)
const API_URL = process.env.VUE_APP_API_URL || '/api';
const API_TIMEOUT = parseInt(process.env.VUE_APP_API_TIMEOUT || '10000', 10);

// Create axios instance with default configuration
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  timeout: API_TIMEOUT, // timeout from environment variable
  withCredentials: true // Enable sending cookies with requests for CSRF token
});

// Log all requests for debugging
apiClient.interceptors.request.use(request => {
  logger.debug('Starting API Request:', request.method, request.url);
  return request;
}, error => {
  logger.error('Request error:', error);
  return Promise.reject(error);
});

// Response interceptor for error handling
apiClient.interceptors.response.use(
  response => response,
  error => {
    const { response } = error;
    
    // Handle different error statuses
    if (response && response.status) {
      switch (response.status) {
        case 401:
          logger.error('Unauthorized access');
          break;
        case 403:
          logger.error('Forbidden access');
          break;
        case 404:
          logger.error('Resource not found');
          break;
        case 500:
          logger.error('Internal server error');
          break;
        default:
          logger.error('API request failed');
      }
    } else {
      logger.error('Network error or server unreachable');
    }
    
    return Promise.reject(error);
  }
);

export default apiClient; 